import PropTypes from 'prop-types';

import CoevaluationItem from './CoevaluationItem/CoevaluationItem';
import CoevaluationComment from './CoevaluationComment/CoevaluationComment';

const Coevaluation = props => {
  return (
    <>
      {props.coevaluationItems &&
        props.coevaluationItems.map(coevaluation => (
          <CoevaluationItem
            notCoeval={props.notCoeval}
            key={coevaluation.idCoevaluationItem}
            coevaluation={coevaluation}
            coevaluationActivity={props.coevaluationActivity}
            idCoevaluationItem={coevaluation.idCoevaluationItem}
          />
        ))}
      {!props.notCoeval && (
        <CoevaluationComment
          coevaluationCommentHandler={
            props.coevaluationCommentHandler
          }
        />
      )}
    </>
  );
};

Coevaluation.propTypes = {
  // eslint-disable-next-line react/require-default-props
  notCoeval: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  coevaluationItems: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  coevaluationActivity: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  coevaluationCommentHandler: PropTypes.func
};

export default Coevaluation;
